import { createContext } from 'react';

// @TODO biome-ignore lint/suspicious/noExplicitAny:
export const PageContextStore = createContext<Vike.PageContext<unknown>>({
  routeParams: {},
  data: undefined,
  config: {},
  configEntries: {},
  exports: {},
  exportsAll: {},
  urlOriginal: '',
  headers: {},
  is404: false,
  isClientSideNavigation: false,
  from: {
    configsStandard: {},
    configsCumulative: {},
    configsComputed: {},
  },
  source: {},
  sources: {},
  url: '',
  pageExports: {},
  urlParsed: {
    origin: null,
    pathname: '',
    pathnameOriginal: '',
    search: {},
    searchAll: {},
    searchOriginal: null,
    hash: '',
    hashOriginal: null,
    hashString: null,
    searchString: null,
  },
  urlPathname: '',
  requests: {},
  fetch: typeof fetch !== 'undefined' ? fetch : async () => new Response(),
});

// export function usePageContext<
//   _T extends Record<string | number | symbol, unknown> | void = Record<
//     string | number | symbol,
//     unknown
//   >,
//   Page extends TPage = PageDefault,
// >() {
//   const pageContext = useContext(PageContextStore) as Vike.PageContext<Page> & {
//     setUser?: (user: API.User | null) => void;
//   };

//   return pageContext;
// }

import { usePageContext } from 'vike-react/usePageContext';

export { usePageContext };
